import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import { RentalPortalPhaseBar } from '../../RentalPortalPhaseBar'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantProfileHeaderInfoItemsSkeleton } from './ApplicantProfileHeaderInfoItemsSkeleton'
import { ApplicantProfilePortalReceivedItem } from './ApplicantProfilePortalReceivedItem'
import {
  APPLICANT_PROFILE_HEADER_INFO_ITEMS_COLUMNS,
  QA_NAME_APPLICANT_PROFILE_PHASE_BAR,
} from './RentalPortalApplicantProfileHeaderInfoItems.constants'
import {
  getApplicantPhaseItems,
  getApplicantPhaseTerminalStatement,
} from './RentalPortalApplicantProfileHeaderInfoItems.utils'

import * as styles from './RentalPortalApplicantProfileHeaderInfoItems.module.css'

function RentalPortalApplicantProfileHeaderInfoItems({ isLoading }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  const timezone = useTimeZone()

  const { applicantData } = useApplicantProfileContext()

  const isPhaseTerminal = Boolean(applicantData?.phase?.is_terminal)

  const phaseItems = getApplicantPhaseItems({
    isTerminal: isPhaseTerminal,
    phases: applicantData?.phases,
    t,
  })

  return (
    <div className={styles.RentalPortalApplicantProfileHeaderInfoItems}>
      <RentalPortalPhaseBar
        isLoading={isLoading}
        items={phaseItems}
        qaName={QA_NAME_APPLICANT_PROFILE_PHASE_BAR}
        terminalStatement={
          isPhaseTerminal
            ? getApplicantPhaseTerminalStatement({
                locale,
                phase: applicantData?.phase,
                t,
                terminalDate: applicantData?.terminal_at,
                timezone,
              })
            : null
        }
      />
      <div
        className={styles.infoGrid}
        style={{
          '--applicant-profile-header-info-items-columns':
            APPLICANT_PROFILE_HEADER_INFO_ITEMS_COLUMNS,
        }}
      >
        {isLoading ? (
          <ApplicantProfileHeaderInfoItemsSkeleton
            className={styles.infoItem}
          />
        ) : (
          <ApplicantProfilePortalReceivedItem
            applicant={applicantData}
            className={styles.infoItem}
            contentWrapperClassName={styles.contentWrapper}
            titleClassName={styles.infoItemTitle}
          />
        )}
      </div>
    </div>
  )
}

export default RentalPortalApplicantProfileHeaderInfoItems
